
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Button } from "../../App.styles";
import Modal from "../Modal";
import Textarea from "../Textarea";
import { useCreateAiPhotoMutation } from "./NubsUpload.state";
import { useSetRecoilState } from "recoil";
import { alertState } from "../AlertDisplay/AlertDisplay.state";
import Spinner from "../Spinner";
import { getErrorMessage } from "../../lib/error";

const ModalAiPhoto = ({ onDismiss, show, useQuery, taskId, onGenerateStart, onGenerateComplete }) => {
    const { game_id } = useParams()
    const { t } = useTranslation()
    const setAlert = useSetRecoilState(alertState)
    const [modalValue, setModalValue] = useState({ prompt: '' })
    const handleDismiss = () => {
        // Clear the prompt value
        setModalValue({ prompt: '' })
        // Close the modal
        onDismiss()
    }
    const { loading, createAiPhoto } = useCreateAiPhotoMutation({
        game_id,
        taskId,
        useQuery,
        mutationOptions: {
            onSuccess: () => {
                handleDismiss()
            },
            onError: (error) => {
                const message = getErrorMessage(error, 'generating an AI photo')
                setAlert({ type: 'error', message, closable: true })
            },
            onSettled: () => {
                onGenerateComplete?.()
            },
        }
    })
    const onSave = e => {
        e.preventDefault()
        const { prompt } = modalValue
        onGenerateStart?.()
        setAlert({
            type: 'info',
            message: t('Your AI photo is generating in the background. It can take up to 5 minutes and will appear here when it is ready.'),
            closable: true,
            autoClose: true,
        })
        const generation = createAiPhoto(prompt)
        handleDismiss()
        generation?.catch?.(() => {})
    }

    return show
        ? (
            <Modal onDismiss={handleDismiss} show={true} size="lg" className="modal--html form-clean">
                <div className="modal-title px-3 py-2">
                    <span dangerouslySetInnerHTML={{ __html: t('AI generated photo') }} />
                </div>
                <div className="modal-body px-3 pb-3">
                    <p dangerouslySetInnerHTML={{
                        __html: t(`Ask our AI to create a photo for your game/challenge. 
                    Tell it what to create. For example, "A photo of a dog wearing a sombrero."`)
                    }} />
                    <p>{t('Generation will continue in the background and can take up to 5 minutes. The image will appear here when it is ready.')}</p>
                    <Textarea
                        name="prompt"
                        useQuery={() => [modalValue, setModalValue]}
                        mode="clean"
                        rows="5"
                        disabled={loading}
                    />
                </div>
                <div className="modal-footer">
                    {
                        !loading && (
                            <Button disabled={loading} className="btn--flat" data-dismiss="modal" onClick={handleDismiss} outline>
                                {t('Cancel')}
                            </Button>
                        )
                    }
                    <Button disabled={loading} className="btn--flat" data-dismiss="modal" onClick={onSave} color="primary">
                        {t('Generate Photo')} {loading ? <Spinner size="0.875rem" /> : null}
                    </Button>
                </div>
            </Modal>
        )
        : null
}

export default ModalAiPhoto
